import { Route, Routes, useLocation } from "react-router-dom";
import { Navbar } from "./layout";
import { Home } from "./pages";
import {
  AboutUs,
  ContactUs,
  Features,
  Hero,
  NavFooter,
  Projects,
  Services,
} from "./components";
import { useEffect } from "react";
import SuccessMessage from "./components/Message/SuccessMessage";
import { useContextHook } from "./Context/ContextOPen";
import { FaAngleDoubleUp } from "react-icons/fa";

const App = () => {
  const { swiperIndex, setSwiperIndex } = useContextHook();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="bg-Secondary body text-white overflow-hidden ">
      {swiperIndex ? (
        <div
          onClick={() => setSwiperIndex(0)}
          className="fixed bottom-10 right-4 bg-Main px-2 py-3 rounded-lg z-20 cursor-pointer"
        >
          <FaAngleDoubleUp
            size={25}
            className="!cursor-pointer relative -z-10"
          />
        </div>
      ) : (
        ""
      )}
      <SuccessMessage />
      <Navbar />
      <div className="">
        <Home />
        <div className="lg:hidden h-[82dvh] overflow-scroll">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="features" element={<Features />} />
            <Route path="services" element={<Services />} />
            <Route path="services" element={<Services />} />
            <Route path="projects" element={<Projects />} />
          </Routes>
        </div>
      </div>
      <NavFooter />
    </div>
  );
};

export default App;
